 var linkPosition = 0;

jQuery("#accordionhome").accordion({
    header: "> div > h3",
    animate: {
        easing: "swing", // You can change this to "linear" or other jQuery easing functions.
        duration: 1 // Duration in milliseconds (600ms = 0.6s)
    },
    heightStyle: "content", // Adjusts to the height of the content inside the accordion.
    collapsible: true,  // Allows all sections to collapse
    active: false        // Initially, no panel is active
});

jQuery(document).ready(function() {
    // Get the current store URL
    var shopDomain = window.location.hostname;

    // Find all anchor links
    jQuery("a").each(function() {
        // Get the href attribute of the link
        var link = jQuery(this).attr("href");

        // Check if the link does not start with the shop domain
        if (link && link.indexOf(shopDomain) === -1 && link.indexOf("http") === 0) {
            // If the link is external, open it in a new tab
            jQuery(this).attr("target", "_blank");
        }
    });


    jQuery('#select_product').on('change', function() {
      window.location.href = this.value;
      //alert( this.value );
    }); 
});


jQuery(document).ready(function(){
  /* client says section on home page*/
    jQuery('.client_says_feedback').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      dots: false, // Removes the dots
      items: 3,
      responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    }
    });
  jQuery('.ourbrandslist').owlCarousel({
      loop: true,
      margin: 10,
      autoplay: true,  
      nav: false,
      autoplayTimeout: 1500, 
      dots: false, // Removes the dots
      items:6,
      responsive:{
        0:{
            items:2
        },
        600:{
            items:4
        },
        1000:{
            items:6
        }
    }
    });
  
    //  jQuery('.influener_video').owlCarousel({
    //   loop: true,     
    //   margin:10,
    //   nav: true,
    //   dots: false, // Removes the dots
    //   items: 4,
    //   responsive:{
    //     0:{
    //         items:1,
    //        stagePadding: 20,
         
    //     },
    //     600:{
    //         items:2
     
    //     },
    //     1000:{
    //         items:3
    //     }
    // }
    // });
 jQuery(document).ready(function() {
  jQuery('.influener_video').slick({
  dots: false,
  infinite: true,
  arrows:true,
  speed: 300,
  centerMode: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  // autoplay: true,
  // autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1499,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
 });


  

  
  jQuery('.homereviewslider').owlCarousel({
    loop:true,
    margin:2,
    nav:true,
    items:4,
    dots: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        },
        1080:{
            items:4
        }
    }
});
    jQuery('.blog_product_slider').owlCarousel({
    loop:true,
    margin:2,
    nav:true,
    items:3,
    dots: false,
    responsive:{
        0:{
            items:1
        },
        768:{
            items:2
        },
        1199:{
            items:3
        }
    }
});


  
    jQuery('.tag_slider .tag_list_item').owlCarousel({
    loop:true,
    margin:2,
    nav:true,
    items:8,
    autoplay:true,
    dots: false,
    responsive:{
        0:{
            items:1
        },
      375:{
            items:1
        },
      414:{
            items:2
        },
        767:{
            items:5
        },
      1199:{
            items:6
        },
        1440:{
            items:8
        }
    }
});

  jQuery('.spectrum_slider').owlCarousel({
    loop:true,
    margin:2,
    nav:true,
    items:1,
    dots: false,  
});

  
/* product page filter */
 // alert(jQuery( window ).width());
 if(jQuery( window ).width() > 750){   
     jQuery(".facets-wrapper").hide();
        jQuery(".fillter_toggel").click(function() {
            jQuery(".facets-wrapper").toggle();
           jQuery(".product-grid-container").toggleClass("div_open");
            
        });
    }  
  });
// load more blog
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#AjaxinateLoop',
    pagination: '#AjaxinatePagination',
    method: 'click',
    offset: 1000
  });
});
  jQuery( function() {
    jQuery( "#tabs" ).tabs();
  } );

 jQuery(document).ready(function() {
    jQuery('#ContactForm-phone').on('input', function() {
        // Remove any non-numeric characters
        this.value = this.value.replace(/[^0-9]/g, '');            
        // Limit the input to 10 digits
        if (this.value.length > 10) {
            this.value = this.value.slice(0, 10);
        }
    });
});

jQuery(".rtl_table_loadmore").click(function() {
    // Toggle classes for height and button state
    jQuery(".comprison_table_wrapper").toggleClass("fullhight_class"); 
    jQuery(this).toggleClass("less_moreload");
    
    // Update the button text based on the current state
    if (jQuery(".comprison_table_wrapper").hasClass("fullhight_class")) {
        jQuery(this).text("Less More");
    } else {
        jQuery(this).text("Load More");
        
        // Scroll to the top of the comparison table if it's collapsed
        var scrollPosition = jQuery('.comprison_table_wrapper').offset().top - jQuery('header').outerHeight();
        jQuery('html, body').animate({ scrollTop: scrollPosition }, 500); // Adjusted scroll speed for smoother animation
    }
});

$(document).ready(function() {
  
  
  // Show the popup when the button is clicked
  jQuery('#show-popup').on('click', function() {
    var id = jQuery(this).attr('data_id');
    alert(id);
    jQuery('.popup').addClass('hidden');
    jQuery('#popup_'+id).removeClass('hidden');
  });

  // Hide the popup when the close button is clicked
  jQuery('#close-popup').on('click', function() {
    
     var id = jQuery(this).attr('data_id');
    alert(id);
   jQuery('#popup_'+id).addClass('hidden');
  });


  //Remove target blank from Gtranslate Language selector link  

 jQuery(document).on('click', '.glink', function(event) {
    var language_link = jQuery(this).attr('href'); // Get the href attribute which is the ID
    event.preventDefault();
    window.location.href = language_link;
    console.log('hellolanguage');  
  });

  //smooth scroll  
 jQuery(document).on('click', '.article-template__content a', function(event) {
    var id_scroll = jQuery(this).attr('href'); // Get the href attribute which is the ID
    if (id_scroll.includes("#")) {
        event.preventDefault(); // Prevent default anchor click behavior. Moved this inside the If and commented the window.location in the Else so that default is prevent only if there are links to scroll to.
        var array = id_scroll.split("#");
        var id_toscroll='#'+array[1]; 
        linkPosition = $(window).scrollTop(); 
        var aaa = jQuery(id_toscroll).offset().top - jQuery('header').height() - 80; // Calculate scroll position. Deducted 80 more to accommodate for the Black Friday and Import Duty notices that we put in the header in Nov 2025.
        jQuery('html, body').animate({ scrollTop: aaa }, 1000); // Scroll to the target smoothly    
      console.log('hello'+linkPosition);
    }else{
       //window.location.href = id_scroll;
    }
  });
});
 jQuery(document).on('click', 'a.comprison_scroll', function(event) {
    event.preventDefault(); 

     var scrollPosition = jQuery('.comprison_table_wrapper').offset().top - jQuery('header').outerHeight();
        jQuery('html, body').animate({ scrollTop: scrollPosition }, 500);
  });


// Back to Top Button
jQuery(document).ready(function() {
  // Show/Hide the back-to-top button after scrolling down 300px
  jQuery(window).scroll(function() {
    if (jQuery(this).scrollTop() > 300) {
      jQuery('#back-to-top').fadeIn();
    } else {
      jQuery('#back-to-top').fadeOut();
    }
  });

  // Smooth scroll to top when button is clicked
  jQuery('.non_blog_backtotop').click(function(e) {
    e.preventDefault();
    jQuery('html, body').animate({ scrollTop: 0 }, 800); // 800ms scroll speed
    return false;
  });
    jQuery('.blog_backtotop').click(function(e) {
    e.preventDefault();
      $('html, body').animate({scrollTop: linkPosition}, 800);
    //jQuery('html, body').animate({ scrollTop: 0 }, 800); // 800ms scroll speed
    return false;
  });
  
});

// Show the pop-up when button is clicked
$('.popupButton').on('click', function() {
  var  id =  $(this).attr('data_id');
  //alert('.fullcontent_'+id);
   const fullContent = $('.fullcontent_'+id).html();
 

  // // Load the fullcontent into the pop-up
   $('.main_container').html(fullContent);

  // // Show the pop-up
   $('#popup').css('display', 'flex');
});

// Close the pop-up when the close button is clicked
$('#closePopup').on('click', function() {
  $('#popup').css('display', 'none');
});

// Close the pop-up if clicked outside of the content
$(window).on('click', function(event) {
  if ($(event.target).is('#popup')) {
    $('#popup').css('display', 'none');
  }
});


jQuery(document).ready(function($) {
  $('.slick.marquee').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    pauseOnHover: true // Pauses on hover
  });
});


 document.addEventListener('DOMContentLoaded', function () {
    const video = document.getElementById('bannerVideo_desktop');
    
    // ✅ Only proceed if the desktop video element exists
    if (video) {
      const muteButton = document.getElementById('muteButton');
      const video_mob = document.getElementById('bannerVideo_mob');

      muteButton.addEventListener('click', function () {
        const unmuteImage = 'https://cdn.shopify.com/s/files/1/0531/8128/4519/files/Volume_Up.svg';
        const muteImage = 'https://cdn.shopify.com/s/files/1/0531/8128/4519/files/Unmute.svg';

        if (window.innerWidth > 767) {
          video_mob.muted = true;
          if (video.muted) {
            video.muted = false;
            muteButton.innerHTML = '<img src="' + unmuteImage + '" class="volumeurl">';
          } else {
            video.muted = true;
            muteButton.innerHTML = '<img src="' + muteImage + '" class="volumeurl">';
          }
        } else {
          video.muted = true;
          if (video_mob.muted) {
            video_mob.muted = false;
            muteButton.innerHTML = '<img src="' + unmuteImage + '" class="volumeurl">';
          } else {
            video_mob.muted = true;
            muteButton.innerHTML = '<img src="' + muteImage + '" class="volumeurl">';
          }
        }
      });

      // Loop the desktop video
      video.addEventListener('ended', function () {
        video.currentTime = 0;
        video.play();
      }, false);
    }
  });

// var videoElement_banner_mob = document.getElementById('bannerVideo_mob');
// videoElement_banner_mob.addEventListener('ended', function() {
//     videoElement_banner_mob.currentTime = 0;
//     videoElement_banner_mob.play();
// }, false);
var videoElement_banner_mob = document.getElementById('bannerVideo_mob');

if (videoElement_banner_mob) {
  videoElement_banner_mob.addEventListener('ended', function() {
    videoElement_banner_mob.currentTime = 0;
    videoElement_banner_mob.play();
  }, false);
}

 

  jQuery(document).ready(function ($) {
    const $video = $('.custom-video');
    const $unmuteBtn = $('.desktop-volume');
    const $muteicon = $unmuteBtn.find('.mute-image');
        const $unmuteicon = $unmuteBtn.find('.unmute-image');

    if ($video.length && $unmuteBtn.length) {
      $unmuteBtn.on('click', function () {
        const isMuted = $video.prop('muted');
        $video.prop('muted', !isMuted);

        // Toggle icon visibility
        if (isMuted) {
          // Now unmuted → hide icon
          $muteicon.css('display', 'none');
          $unmuteicon.css('display', 'block');
          
        } else {
          // Now muted → show icon
          $unmuteicon.css('display', 'none');
          $muteicon.css('display', 'block');
          
        }
      });
    }
  });


  jQuery(document).ready(function ($) {
    const $video = $('.custom-video-mobile');
    const $unmuteBtn = $('.mobile-volume');
    const $muteicon = $unmuteBtn.find('.mute-image');
        const $unmuteicon = $unmuteBtn.find('.unmute-image');

    if ($video.length && $unmuteBtn.length) {
      $unmuteBtn.on('click', function () {
        const isMuted = $video.prop('muted');
        $video.prop('muted', !isMuted);

        // Toggle icon visibility
        if (isMuted) {
          // Now unmuted → hide icon
          $muteicon.css('display', 'none');
          $unmuteicon.css('display', 'block');
          
        } else {
          // Now muted → show icon
          $unmuteicon.css('display', 'none');
          $muteicon.css('display', 'block');
          
        }
      });
    }
  });

// our philosophy ========
  jQuery(document).ready(function ($) {
    const $video = $('.custom-video-our');
    const $unmuteBtn = $('.unmuteour-btn');
    const $muteicon = $unmuteBtn.find('.muteour-image');
        const $unmuteicon = $unmuteBtn.find('.unmuteour-image');

    if ($video.length && $unmuteBtn.length) {
      $unmuteBtn.on('click', function () {
        const isMuted = $video.prop('muted');
        $video.prop('muted', !isMuted);

        // Toggle icon visibility
        if (isMuted) {
          // Now unmuted → hide icon
          $muteicon.css('display', 'none');
          $unmuteicon.css('display', 'block');
          
        } else {
          // Now muted → show icon
          $unmuteicon.css('display', 'none');
          $muteicon.css('display', 'block');
          
        }
      });
    }
  });


// influencer video ===============
  jQuery(document).ready(function ($) {
  const $videos = $('.custom-video-influencer');
  const $unmuteBtn = $('.unmute-btn-influ');
  const $muteicon = $unmuteBtn.find('.mute-image');
  const $unmuteicon = $unmuteBtn.find('.unmute-image');

  function updateIcons(isMuted) {
    if (isMuted) {
      $unmuteicon.css('display', 'none');
      $muteicon.css('display', 'block');
    } else {
      $muteicon.css('display', 'none');
      $unmuteicon.css('display', 'block');
    }
  }

  if ($videos.length && $unmuteBtn.length) {
    $unmuteBtn.on('click', function () {
      const $centerVideo = $('.influener_video_home .slick-center video.custom-video-influencer');
      const isMuted = $centerVideo.prop('muted');

      // Toggle mute state only for center video
      $centerVideo.prop('muted', !isMuted);

      // Update icons
      updateIcons(!isMuted);
    });

    // On Slick change - auto mute center video and show mute icon
    $('.influener_video_home').on('afterChange', function (event, slick, currentSlide) {
      const $centerVideo = $('.influener_video_home .slick-center video.custom-video-influencer');

      // Mute all videos first
      $videos.prop('muted', true);

      // Mute center video and show mute icon
      if ($centerVideo.length) {
        $centerVideo.prop('muted', true);
        updateIcons(true);
      }
    });
  }
});



// Select all video elements
const videos = document.querySelectorAll('video');

videos.forEach(video => {
  // Assuming each video has a related unmute/mute button
  const $unmuteBtn = $(video).siblings('.unmute-btn'); // adjust if needed
  const $muteicon = $unmuteBtn.find('.mute-image');
  const $unmuteicon = $unmuteBtn.find('.unmute-image');

  video.addEventListener('volumechange', function() {
    const isMuted = video.muted || video.volume === 0;

    // Update the mute/unmute icons
    if (isMuted) {
      $unmuteicon.hide();
      $muteicon.show();
    } else {
      $muteicon.hide();
      $unmuteicon.show();
    }

    // Mute all other videos when this one is unmuted
    if (!isMuted) {
      videos.forEach(otherVideo => {
        if (otherVideo !== video) {
          otherVideo.muted = true;

          // Update icons for other videos too
          const $otherUnmuteBtn = $(otherVideo).siblings('.unmute-btn ');
          const $otherMuteicon = $otherUnmuteBtn.find('.mute-image');
          const $otherUnmuteicon = $otherUnmuteBtn.find('.unmute-image');

          $otherUnmuteicon.hide();
          $otherMuteicon.show();
        }
      });
    }
  });
});


// Select all video elements
// const videos = document.querySelectorAll('video');

videos.forEach(video => {
  // Assuming each video has a related unmute/mute button
  const $unmuteBtn = $(video).siblings('.unmuteour-btn'); // adjust if needed
  const $muteicon = $unmuteBtn.find('.muteour-image');
  const $unmuteicon = $unmuteBtn.find('.unmuteour-image');

  video.addEventListener('volumechange', function() {
    const isMuted = video.muted || video.volume === 0;

    // Update the mute/unmute icons
    if (isMuted) {
      $unmuteicon.hide();
      $muteicon.show();
    } else {
      $muteicon.hide();
      $unmuteicon.show();
    }

    // Mute all other videos when this one is unmuted
    if (!isMuted) {
      videos.forEach(otherVideo => {
        if (otherVideo !== video) {
          otherVideo.muted = true;

          // Update icons for other videos too
          const $otherUnmuteBtn = $(otherVideo).siblings(' .unmuteour-btn');
          const $otherMuteicon = $otherUnmuteBtn.find('.muteour-image');
          const $otherUnmuteicon = $otherUnmuteBtn.find('.unmuteour-image');

          $otherUnmuteicon.hide();
          $otherMuteicon.show();
        }
      });
    }
  });
});






 jQuery(document).ready(function () {
$('.result-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1201,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows:false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


 })


  jQuery(document).ready(function($){
    $('.large-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.nav-slider'
    });

    $('.nav-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.large-slider',
      focusOnSelect: true,
      arrows: false,
      dots: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  });





jQuery(document).ready(function($) {
  var $carousel = $('.influener_video_home');

  function pauseAllVideos() {
    $('.influener_video_home .item video').each(function() {
      this.pause();
      this.currentTime = 0;
    });
  }

  function playVideoByIndex(index) {
    var $currentSlide = $carousel.find('.slick-slide[data-slick-index="' + index + '"]');
    var $video = $currentSlide.find('video');

    if ($video.length) {
      $video.prop('muted', true);
      $video[0].play();
    }
  }

  $carousel.on('init', function(event, slick){
    pauseAllVideos();
    playVideoByIndex(slick.currentSlide);
  });

  $carousel.slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $carousel.on('afterChange', function(event, slick, currentSlide){
    pauseAllVideos();
    playVideoByIndex(currentSlide);
  });

  // Force slick to update layout
  $carousel.slick('setPosition');
});


// lazy load video ------------------------
// document.addEventListener("DOMContentLoaded", function () {
//     const lazyVideos = document.querySelectorAll("video.lazy-video");

//     // if ("IntersectionObserver" in window) {
//       const videoObserver = new IntersectionObserver(function (entries, observer) {
//         entries.forEach(function (entry) {
//           if (entry.isIntersecting) {
//             const video = entry.target;
//             const source = document.createElement("source");
//             source.src = video.getAttribute("data-src");
//             video.appendChild(source);
//             video.load();
//             video.classList.remove("lazy-video");
//             videoObserver.unobserve(video);
//           }
//         });
//       });

//       lazyVideos.forEach(function (video) {
//         videoObserver.observe(video);
//       });
//     // }
//   });


document.addEventListener("DOMContentLoaded", function () {
    const lazyVideos = document.querySelectorAll("video.lazy-video");

    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const video = entry.target;
            const src = video.getAttribute("data-src");

            if (src) {
              video.src = src;
              video.load();
              videoObserver.unobserve(video);
            }
          }
        });
      });

      lazyVideos.forEach(function (video) {
        videoObserver.observe(video);
      });
    } else {
      // Fallback: load all videos immediately
      lazyVideos.forEach(function (video) {
        const src = video.getAttribute("data-src");
        if (src) {
          video.src = src;
          video.load();
        }
      });
    }
  });




